import React, { useContext, useEffect } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import BulkActionControl from '@Components/BulkAction/BulkActionControl'
import './index.scss'

const WorkMergeBulkAction = () => {
    const { publicSearchWorksStore, catalogSearchBulkActionStore } = useContext(StoresContext)

    const worksOnPage = publicSearchWorksStore.publicSearchByWorkCriteriaWorks?.works ?? []
    const selectionCount = catalogSearchBulkActionStore.idsSelectedForBulkAction.size

    useEffect(() => {
        catalogSearchBulkActionStore.syncSelectedWorks(worksOnPage)
    }, [publicSearchWorksStore.publicSearchByWorkCriteriaWorks, selectionCount])

    return (
        <div className="work-merge-bulk-action">
            <BulkActionControl
                enabledWorks={worksOnPage}
                idList={worksOnPage.map((work) => work.id).filter((id): id is number => id !== undefined)}
                bulkSelectionCountText="Report Duplicates"
                totalSelectionCount={publicSearchWorksStore.publicSearchByWorkCriteriaWorks?.count ?? 0}
                bulkActionStore={catalogSearchBulkActionStore}
                pagination={publicSearchWorksStore.pagination}
                isSubmitDisabled={selectionCount === 0}
                submitButtonText="Select works to merge"
                submitButtonOnClick={() => catalogSearchBulkActionStore.startMergeFromSelection()}
                instructions="Select all works that are duplicates, then click the 'Select works to merge' button. Your selections are kept if you run another search, but changing pages clears them. "
            />
        </div>
    )
}

export default observer(WorkMergeBulkAction)
